"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = void 0;
const storeCollection = new Map();
// This is the ensure that the storeCollection won't get overridden or manipulated.
function getStore(storeName, initialValue) {
    // Initialize if its not available yet.
    if (!storeCollection.get(storeName)) {
        storeCollection.set(storeName, initialValue || new Map());
    }
    return storeCollection.get(storeName);
}
exports.getStore = getStore;
